.frame {
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-lg);
  background: var(--color-bg-elevated);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.35);
  overflow: hidden;
}

.frameAtmosphere {
  width: fit-content;
  max-width: 100%;
  justify-self: center;
}

.chrome {
  display: flex;
  gap: 6px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--color-border);
  background: rgba(0, 0, 0, 0.35);
}

.chrome span {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
}

.screen {
  position: relative;
  min-height: 200px;
  padding: 16px;
}

.screenScreenshot {
  min-height: 0;
  padding: 0;
  background: #0a0810;
  line-height: 0;
}

.screenAtmosphere {
  min-height: 0;
  width: fit-content;
}
